export default __webpack_public_path__ + "5d9c4d98f64789e685c9f5c74c400fe9.png";